import { motion } from "framer-motion";
import { whyHapo } from "../../data/content";
import { Eyebrow, Reveal, ArrowLink, EASE } from "./motion";

export default function WhyHapo() {
  return (
    <section className="bg-white px-6 py-24 lg:px-12 lg:py-[160px]" aria-label="Why Hapo">
      <Eyebrow>Why Hapo</Eyebrow>
      <h2 className="mt-5 max-w-2xl text-4xl font-extrabold tracking-tighter text-ink sm:text-5xl lg:text-6xl">
        Built differently, on purpose.
      </h2>

      <div className="mt-20">
        {whyHapo.map((item, i) => (
          <div
            key={item.num}
            className="grid items-center gap-10 border-t border-ink/10 py-16 md:grid-cols-2 lg:gap-20 lg:py-20"
          >
            <Reveal className={i % 2 === 1 ? "md:order-2" : ""}>
              <span className="text-6xl font-extrabold tracking-tighter text-gold lg:text-8xl">{item.num}</span>
              <h3 className="mt-6 text-2xl font-bold tracking-tight text-ink sm:text-3xl lg:text-4xl">
                {item.title}
              </h3>
              <p className="mt-5 max-w-lg text-sm leading-loose text-smoke md:text-base">{item.text}</p>
              {item.link && (
                <div className="mt-8">
                  <ArrowLink to={item.link.to} testId="why-hapo-learn-more">
                    {item.link.label}
                  </ArrowLink>
                </div>
              )}
            </Reveal>
            <Reveal delay={0.1} className={i % 2 === 1 ? "md:order-1" : ""}>
              <div className="overflow-hidden">
                <motion.img
                  initial={{ scale: 1.12 }}
                  whileInView={{ scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 1.2, ease: EASE }}
                  src={item.image}
                  alt={`${item.title} — placeholder image`}
                  loading="lazy"
                  className="aspect-[4/3] w-full object-cover"
                />
              </div>
            </Reveal>
          </div>
        ))}
      </div>
    </section>
  );
}
